/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import poseFace_IconURL from './pose-face.png';
import poseFace_InsetIconURL from './pose-face-small.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Face Sensing"
        description="name for the Face Sensing extension"
        id="extension.poseFace.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Sense face movement with the camera."
        description="description for the Face Sensing extension"
        id="extension.poseFace.description"
    />
  ),
	iconURL: poseFace_IconURL,
	insetIconURL: poseFace_InsetIconURL,
	tags: ["Dancing with AI","Made by PRG"],
	featured: true,
	extensionId: 'poseFace',
}